var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExpandIcon } from '@marketing-icons';
import { clsx } from 'clsx';
var baseStyles = 'font-medium px-6 py-2 md:px-12 border rounded-lg text-sm-med-m md:text-sm-med-d ' +
    'whitespace-nowrap text-text-body hover:text-text-white border-shoe ' +
    'hover:bg-bone-950 transition-colors h-10';
function BlogTopic(_a) {
    var topic = _a.topic, onClick = _a.onClick, onChange = _a.onChange, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c;
    return (_jsxs("div", __assign({ className: clsx(baseStyles, 'text-center', isSelected ? 'bg-text-body' : 'bg-transparent', isSelected && 'text-text-white', isLoading ? 'cursor-progress' : 'cursor-pointer'), onClick: onClick }, { children: [_jsx("input", { id: topic, type: "checkbox", disabled: isLoading, onChange: onChange, checked: isSelected, className: "sr-only" }), _jsx("label", __assign({ className: clsx(isLoading ? 'cursor-progress' : 'cursor-pointer'), htmlFor: topic }, { children: topic }))] })));
}
var LoadMoreTopics = function (_a) {
    var onClick = _a.onClick;
    return (_jsxs("button", __assign({ className: clsx(baseStyles, 'flex justify-center items-center bg-action-surface-primary group'), onClick: onClick }, { children: ["Load More", _jsx(ExpandIcon, { className: "ml-2 group-hover:text-text-white text-icon-dark transition-colors" })] })));
};
export { LoadMoreTopics, BlogTopic };
export default BlogTopic;
